import styles from "../landing-page-four.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";

interface ValuePropSectionProps {
  onClick: () => void;
}

export const ValuePropSection = (props: ValuePropSectionProps) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.valuePropContent}>
        <h1 className={styles.valuePropTitle}>Your adventures, on your wall</h1>
        <p className={styles.valuePropDescription}>
          Turn the GPS route from your favourite hike, run, or ride into a
          stunning piece of wall art. Fully customisable and printed on premium
          materials — a personal keepsake that belongs right next to your
          favourite photos.
        </p>
        <p className={styles.valuePropDescription}>
          The perfect gift to celebrate any adventure.
        </p>
        <CTAButton onClick={props.onClick} title="Start designing" />
      </div>
    </div>
  );
};
